export default {
    department: '部门',
    expert: '专家',
    lecturer: '讲师',
    reply: '回复',
    noData: '没有数据',
    hour: '时',
    minute: '分',
    years: '年',
    months: '月',
    day: '日',
    position: '岗位',
    operation: {
        title: '总体运营',
        boardName: '大数据看板',
        totalVisit: '累计访问次数',
    },
};
